import { OrientacionI } from "interfaces/Orientacion";
import { PlanEstudioI } from "interfaces/PlanEstudio";
import React, { ReactNode } from "react";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: OrientacionI;
  renderActions?: (elemento: OrientacionI) => ReactNode;
}

export const OrientacionesRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`OrientacionesTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
